import './graph.scss';

import Component from '../component/component';

export default class Graph extends Component {

    static initSelector: string = '.js-graph';

    public value: number;

    constructor(target: HTMLElement) {
        super(target);
        this.value = (Number(this.element.getAttribute('data-value')) / 100);
        this.onLoad();
    }

    public onLoad(): void {
        const transformStyles: string[] = ['-webkit-transform', '-ms-transform', 'transform'];
        const rotation: number = Math.floor(this.value * 180);
        const fillRotation: number = rotation;
        const fixRotation: number = rotation * 2;

        transformStyles.forEach((name: string, i: number) => {
            this.element.querySelectorAll('.graph__circle .graph__fill, .graph__circle .graph__mask.graph__mask--full')
                .forEach((item: HTMLElement) => item.style[transformStyles[i]] = 'rotate(' + fillRotation + 'deg)');
            this.element.querySelectorAll('.graph__circle .graph__fill.graph__fill--fix')
                .forEach((item: HTMLElement) => item.style[transformStyles[i]] = 'rotate(' + fixRotation + 'deg)');
        });
    }

}
